import { render, staticRenderFns } from "./PrinterStatistics.vue?vue&type=template&id=2492b180&scoped=true"
import script from "./PrinterStatistics.vue?vue&type=script&lang=js"
export * from "./PrinterStatistics.vue?vue&type=script&lang=js"
import style0 from "./PrinterStatistics.vue?vue&type=style&index=0&id=2492b180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2492b180",
  null
  
)

export default component.exports